export enum ReportKey {
  PermittingOverview = 'permittingOverview',
  BPExpiration = 'bpExpiration',
  DatesAtAGlance = 'datesAtAGlance',
  NewClosedProjects = 'newClosedProjects',
  OverdueTasks = 'overdueTasks',
  ProjectDuration = 'projectDuration',
  StructuralPassFail = 'structuralPassFail',
}
